// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"static_page_wrapper__1bHab","mainImage":"static_page_mainImage__2bzSs"};